module.exports = __webpack_public_path__ + "images/category_lp/pc/media8_e319f5758a9111c37c537d253e5013c2.jpg";